import { render, staticRenderFns } from "./UdefUserChip.vue?vue&type=template&id=69da8432&scoped=true&"
import script from "./UdefUserChip.vue?vue&type=script&lang=js&"
export * from "./UdefUserChip.vue?vue&type=script&lang=js&"
import style0 from "./UdefUserChip.vue?vue&type=style&index=0&id=69da8432&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69da8432",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAvatar,VImg})
